<template>
<div class="chart chart-move">
  <!-- <v-layout  v-if="editMode" class="chart-tool">
    <v-flex row>
      <v-spacer></v-spacer>
      <v-btn flat icon dark slot="activator" v-scroll-to="'#down'" @click="$emit('duplicate-chart', slice)">
        <v-tooltip bottom>
          <v-icon small slot="activator">file_copy</v-icon>
          <span>Duplicate Chart</span>
        </v-tooltip>
      </v-btn>
      <v-btn flat icon dark slot="activator" @click="$emit('edit-chart', chartId)">
        <v-tooltip bottom>
          <v-icon small slot="activator">build</v-icon>
          <span>Edit Chart</span>
        </v-tooltip>
      </v-btn>
      <v-btn flat icon dark slot="activator" @click="$emit('deleteChart', chartId)">
        <v-tooltip bottom>
          <v-icon small slot="activator">remove_circle_outline</v-icon>
          <span>Delete Chart</span>
        </v-tooltip>
      </v-btn>
    </v-flex>
  </v-layout> -->
    <v-layout v-if="editMode" class="chart-tool" >
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" style="outline: none;" @click="action">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile @click="$emit('duplicate-chart', slice)" v-scroll-to="'#down'">
              <v-icon size="16" style="color: #757575;">file_copy</v-icon>
              <v-list-tile-title style=" margin-left: 5px; color: #757575;">Duplicate</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('edit-chart', chartId)" >
              <v-icon size="16" style="color: #757575;">build</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Edit</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('deleteChart', chartId)" >
              <v-icon size="16" style="color: #757575;">remove_circle_outline</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Delete</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
    </v-layout>
    <v-layout v-else-if="previewMode === true" mx-0 my-1>
    </v-layout>
    <v-layout v-else class="extand-chart">
      <v-flex row>
        <v-spacer></v-spacer>
        <v-btn
          flat
          icon
          dark
          style="outline: none;"
          slot="activator"
          class="btn-zoom-chart"
          @click="$emit('full-chart', chartId)"
        >
          <v-tooltip bottom>
            <v-icon slot="activator">zoom_in</v-icon>
            <span>Full Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-chart
    @click="handleChartClick"
    ref="options"
    @init="initChart"
    :init-Options="initOptions"
    :options="options"
    :autoresize="true"
    :style="{height:height, width:width}"
    ></v-chart>
</div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/visualMap'
import 'echarts/map/js/world'
import axios from 'axios'

export default {
  name: 'vue-map',
  components: {
    'v-chart': ECharts
  },
  props: {
    text: {
      type: String
    },
    user_index: {
      type: String
    },
    user_inst: {
      type: String
    },
    startTime: {
      type: [String, Number]
    },
    endTime: {
      type: [String, Number]
    },
    topLimit: {
      type: Number,
      default: 10
    },
    field: {
      type: String,
      default: 'geoip.country_name.keyword'
    },
    stores: {
      type: Array
    },
    subFilter: {
      type: String
    },
    valid: {
      type: Boolean
    },
    chartId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'Untitle'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '90%'
    },
    editMode: {
      type: Boolean,
      default: false
    },
    slice: {
      type: [Object]
    },
    index_now: {
      type: String
    },
    previewMode: {
      type: Boolean,
      default: false
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mapData: [],
      options: {},
      initOptions: {renderer: 'canvas'},
      sub: ''
    }
  },
  async created () {
    if (!this.user_index) {
      this.user_index = this.index_now
    }
  },
  async mounted () {
    await this.initChart()
    await this.beforeload()
  },
  methods: {
    async initChart () {
      this.$refs.options.showLoading({
        color: '#4ea397',
        maskColor: 'transparent',
        textColor: '#ccc'
      })
      if (this.subFilter !== '*' && this.text !== '') {
        this.sub = ''
        this.sub = `${this.subFilter} AND ${this.text}`
      } else if (this.subFilter !== '*') {
        this.sub = ''
        this.sub = `${this.subFilter}`
      } else {
      }
      let response = await axios.post(apiUrl + '/api/query/prop', {
        start: this.startTime,
        end: this.endTime,
        instance: this.user_inst,
        index: this.user_index,
        field: this.field,
        limit: this.topLimit,
        orderby: '_count',
        fieldsum: '',
        stores: this.stores,
        sub: this.sub,
        text: this.text
      })
      this.$refs.options.hideLoading()
      // if (response.data.msg) {
      //   this.options = {
      //     title: {
      //       show: true,
      //       text: this.chartName,
      //       textStyle: {
      //         color: '#ccc',
      //         fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
      //       }
      //     },
      //     backgroundColor: 'transparent',
      //     graphic: {
      //       type: 'text',
      //       left: 'center',
      //       top: 'middle',
      //       style: {
      //         text: 'Request time out.',
      //         font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
      //         fill: '#ccc'
      //       }
      //     },
      //     series: []
      //   }
      //   return
      // }
      let i
      for (i = 0; i < response.data.length; i++) {
        if (response.data[i].key !== 'Reserved') {
          let temp = {}
          temp.name = response.data[i].key
          temp.value = response.data[i].doc_count
          this.mapData.push(temp)
        }
      }
      let min = Infinity
      let max = 0
      for (i = 0; i < response.data.length; i++) {
        if (min > response.data[i].doc_count) {
          min = response.data[i].doc_count
        }
      }

      for (i = 0; i < response.data.length; i++) {
        if (max < response.data[i].doc_count) {
          max = response.data[i].doc_count
        }
      }
      if (Array.isArray(response.data) && response.data.length) {
        this.options = {
          backgroundColor: 'transparent',
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          geo: {
            map: 'world',
            type: 'map',
            left: 0,
            right: 0,
            roam: true,
            zoome: 1,
            label: {
              emphasis: {
                textStyle: {
                  color: '#ccc'
                }
              }
            },
            itemStyle: {
              normal: {
                  color: '#1B1B1A',
                  borderColor: 'white'
              },
              emphasis: {
                  areaColor: '#2a333d'
              }
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              if (params.value) {
                return params.value
              } else {
                return 'N/A'
              }
            }
          },
          visualMap: {
            show: true,
            min: min,
            max: max,
            calculable: true,
            textStyle: {
              color: '#ccc'
            },
            inRange: {
              color: ['#4AAAF6', '#194682']
            }
          },
          series: [{
            type: 'scatter',
            coordinateSystem: 'geo'
          },
          {
            name: 'destinationIP',
            type: 'map',
            geoIndex: 0,
            data: this.mapData
          }]
        }
      } else {
        this.options = {
          title: {
            show: true,
            text: this.chartName,
            textStyle: {
              color: '#ccc',
              fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            }
          },
          backgroundColor: 'transparent',
          graphic: {
            type: 'text',
            left: 'center',
            top: 'middle',
            style: {
              text: 'No data',
              font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
              fill: '#ccc'
            }
          },
          series: []
        }
      }
    },
    beforeload () {
      this.$emit('loadChart', 'load', 'x-map')
    },
    handleChartClick (param) {
      this.key = param.name
      this.field = this.field
      this.$emit('setkey', this.startTime, this.endTime, this.key, this.field)
    },
    deleteChart () {
      this.$emit('deleteChart', this.chartId)
    },
    duplicateChart () {
      this.$emit('duplicateChart', this.slice)
    },
    action () {
      this.$emit('actionToChart')
    }
  },
  watch: {
    startTime: {
      handler: function (startTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.mapData = []
        this.options = {}
        this.initChart()
      }
    },
    endTime: {
      handler: function (endTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.mapData = []
        this.options = {}
        this.initChart()
      }
    },
    stores: {
      handler: function (stores) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.mapData = []
        this.options = {}
        this.initChart()
      }
    },
    text: {
      handler: function (text) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
      this.mapData = []
      this.options = {}
      this.initChart()
      }
    },
    user_index: {
      handler: function (user_index) {
        if (this.user_index) {
          this.mapData = []
          this.option = {}
          this.initChart()
        }
      }
    },
    index_now: {
      handler: function (user_index) {
        this.user_index = this.index_now
      }
    },
    reloadchart: {
      handler: function (val) {
        this.options = {}
        this.initChart()
      }
    }
  }
}
</script>

<style scoped>
/* .chart {
  min-height: 500px
} */
</style>



// WEBPACK FOOTER //
// src/components/x-map.vue